var Fullscreen = {

  cachedValue: null,

  is: function() {

    if ( this.cachedValue !== null ) {
      return this.cachedValue;
    }

    return ( this.cachedValue = !!navigator.standalone );
  }

};